<!-- <app-drawer [customClass]="" [visible]="true" (visibleChange)="close()"> -->

<div class="container py-2 background-grey">
  <div class="row justify-content-center border-bottom sticky-top background-grey">

    <h4 class="text-center font-weight-bold text-primary mt-2 mb-1">Here's Your Gift Card!</h4>
  </div>
  <div class="row" *ngIf="giftcard">

    <div class="gift-card-page">
      <div class="card main-card border-0 background-grey">
        <div class="card-body p-0">

          <!-- STEP 4 -->
          <div class="p-3 p-md-4 content-area success-screen">


            <!-- <div class="text-center mb-3">
                <img *ngIf="selectedTheme" [src]="selectedTheme.imageUrl" [alt]="selectedTheme.name"
                  class="success-card-image" />
              </div> -->

            <div #screen class="gift-card mb-2">
              <div class="card-image">
                <img [src]="giftcard.graphic" alt="Gift Card" />
              </div>

              <div class="card-footer-info">
                <div class="card-name card-name font-weight-bold">
                  {{ giftcard.name }}
                </div>

                <div class="barcode-area">
                  <div class="fake-barcode">
                    <img width="155px" [src]="imageSource">
                  </div>
                  <div class="barcode-number">
                    {{ giftcard.code }}
                  </div>
                </div>

                <div class="card-right">
                  <div class="amount">RM {{ giftcard.amount }}</div>
                  <div class="valid">Valid: {{ giftcard.expiry | date:'dd/MM/yyyy' }}</div>
                </div>
              </div>
            </div>

            <div class="text-center purchased-date mb-4">
              Purchased on: {{ giftcard.purchased_date | date:'dd/MM/yyyy' }}
            </div>

            <div class="success-summary mx-auto mb-4">
              <div class="row no-gutters mb-1">
                <div class="col-4 font-weight-bold">Card</div>
                <div class="col-1 font-weight-bold text-center">:</div>
                <div class="col-7">{{ giftcard?.name }}</div>
              </div>

              <div class="row no-gutters mb-1">
                <div class="col-4 font-weight-bold">Amount</div>
                <div class="col-1 font-weight-bold text-center">:</div>
                <div class="col-7">RM {{ giftcard.amount }}</div>
              </div>

              <div class="row no-gutters">
                <div class="col-4 font-weight-bold">Validity</div>
                <div class="col-1 font-weight-bold text-center">:</div>
                <div class="col-7">
                  {{ giftcard.expiry |date:'dd/MM/yyyy' }}
                  <span *ngIf="selectedGiftCard?.validityText">({{ giftcard?.validityText }})</span>
                </div>
              </div>
            </div>

            <div *ngIf="false" class="text-center gifted-text mb-4">
              <div>You've gifted the above gift card to:</div>
              <div class="gifted-email"></div>
            </div>

            <div class="text-center mb-3">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <button *ngIf="!isLoading" type="button" class="btn btn-link download-link p-0" (click)="downloadGiftCard()">
                <i class="fa fa-download mr-2"></i>
                Download Gift Card
              </button>
            </div>
          </div>

          <!-- Footer -->
          <div *ngIf="false" class="footer-bar d-flex justify-content-center align-items-center">
            <!-- step 1 -->
            <button *ngIf="step === 1" type="button" class="btn btn-dark action-btn" [disabled]="form.invalid"
              (click)="goToReview()">
              Next
            </button>




          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<app-loading-component></app-loading-component>
<!-- </app-drawer> -->